import actions from "./actions";
import mutations from "./mutations";

export default {
  state: {
    carInfo: {}
  },
  mutations,
  actions
};
